import { Component, OnInit } from '@angular/core';
import { BaseActComponent } from 'app/_controls/base-act.component';

// RxJs
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { GeoType } from 'app/_core/predefined/enums';
import { CareManagerFilter, Language, PageInfo, CareManager, ListOfValues } from 'app/_core/models';
import { GlobalService } from 'app/_core/api-access/global.service';
import { CareManagerService } from 'app/_core/api-access/caremanager.service';
import { MediaService } from 'app/_core/api-access/media.service';
@Component({
  selector: 'app-caremanager-list-extend',
  templateUrl: './caremanager-list-extend.component.html'
})

export class CareManagerListExtendComponent extends BaseActComponent implements OnInit {

  public readonly careManagers$: Observable<CareManager[]>;
  public readonly pageInfo$: Observable<PageInfo>;
  public readonly geoType = GeoType;

  // Keep form value
  public careManagerFilter: CareManagerFilter = new CareManagerFilter();

  // Pagination
  public pageOffset: number;
  public pageLimit: number;
  public pageNumberSelected: number;

  public globalData: ListOfValues;

  constructor(
    private careManagerService: CareManagerService,
    private route: ActivatedRoute,
    private router: Router,
    private globalService: GlobalService,
    private mediaService: MediaService,) {
    super();

    // Subscribe to entire collection
    this.careManagers$ = this.careManagerService.careManagersObs;
    // Page info
    this.pageInfo$ = this.careManagerService.pageInfoObs;
  }

  loadGlobal() {
    if (this.globalService.getCacheGlobal())
      this.globalData = this.globalService.getCacheGlobal();
    else
      this.globalService.getGlobal().pipe(first()).subscribe(global => {
        this.globalData = global;
        this.globalService.setCacheGlobal(global);
      });
  }

  ngOnInit(): void {
    this.loadGlobal();
    // Process
    this.route.queryParamMap.subscribe(params => {
      this.careManagerFilter.Name = params.get('name');

      // Get filter values from params
      this.careManagerFilter.GeoId = +params.get('geo_id');
      this.careManagerFilter.GeoType = params.get('geo_type');
      this.careManagerFilter.GeoName = params.get('geo_name');

      // TODO: should get it from api, get detail for geotype and id above, or return on result together.
      this.careManagerFilter.GeoCityId = +params.get("geo_city_id");
      this.careManagerFilter.GeoCityName = params.get("geo_city_name");
      this.careManagerFilter.GeoCountyId = +params.get("geo_county_id");
      this.careManagerFilter.GeoCountyName = params.get("geo_county_name");
      this.careManagerFilter.GeoStateId = +params.get("geo_state_id");
      this.careManagerFilter.GeoStateName = params.get("geo_state_name");

      // Other params
      this.careManagerFilter.Distmi = +params.get('distmi') || null;
      this.careManagerFilter.SpecialtyId = +params.get('specialty_id') || null;

      // Populate languages from ids
      const languageIdsText = params.get('language_ids');
      let languageIds: String[] = [];
      if (languageIdsText)
        languageIds = languageIdsText.split(',');

      let languages: Language[] = [];
      if (languageIds.length > 0)
        languages = languageIds.map(id => {
          const index = this.globalData.Languages.findIndex(l => l.Id === +id);
          if (index > -1)
            return this.globalData.Languages[index];
        });

      // Languages parameter
      this.careManagerFilter.Languages = languages;

      // Pagination
      const offset: number = +params.get("page_offset");
      this.pageOffset = offset ? offset : 0;

      const limit: number = +params.get("page_limit");
      this.pageLimit = limit ? limit : 12;

      // Load data
      this.careManagerService.load(this.pageOffset, this.pageLimit, this.careManagerFilter);
    });
  }

  getImageUrl(guid: string) {
    return this.mediaService.getImageUrl(guid);
  }

  onPaginationChange(pageNumber: number, totalPage: number) {
    if (pageNumber < 1 || pageNumber > totalPage) {
      return;
    }

    this.pageNumberSelected = pageNumber;
    this.pageOffset = (pageNumber - 1) * this.pageLimit;

    // Load data with new page and current condition
    this.careManagerService.load(this.pageOffset, this.pageLimit, this.careManagerFilter);
  }

  redirectTo(uri: string, params: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      // Query params
      params ? this.router.navigate([uri], { queryParams: params }) : this.router.navigate([uri])
    );
  }

  getFilter(filter: CareManagerFilter) {
    if (!filter)
      return;

    // Reset pageOffset, and load with new conditions
    this.pageOffset = 0;
    this.careManagerService.load(this.pageOffset, this.pageLimit, filter);
  }
}
